import { useState } from "react";
import { LoginScreen } from "../components/LoginScreen";
import { SignupScreen } from "../components/SignupScreen";
import { OTPScreen } from "../components/OTPScreen";
import { useLocation, useNavigate } from "react-router-dom";


export default function LoginPage() {
  const [currentScreen, setCurrentScreen] = useState("login");
  const [phoneNumber, setPhoneNumber] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const mode = location.state?.mode;
  const from = location.state?.from;
  const redirectAfterAuth = () => {
    navigate(from || "/", {
      replace: true,
      state: mode ? { mode } : undefined,
    });
  };

  const handleNavigateToSignup = () => setCurrentScreen("signup");
  const handleNavigateToLogin = () => setCurrentScreen("login");
  const handleNavigateToOTP = (phone) => {
    setPhoneNumber(phone);
    setCurrentScreen("otp");
  };
  const handleVerify = () => {
    console.log("Verification successful!");
    window.location.href = "/dashboard"; // Redirect after verification
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      {/* Mobile Header */}
      <div className="lg:hidden bg-white p-4 shadow-sm">
        {/* <Logo /> */}
      </div>

      {/* Hero Section for Desktop (optional)
      <HeroSection /> */}

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Desktop Logo */}
        <div className="hidden lg:block bg-white p-6">
          {/* <Logo /> */}
        </div>

        {/* Conditional Rendering of Screens */}
        <div className="flex-1">
          {currentScreen === "login" && (
            <LoginScreen onNavigateToSignup={handleNavigateToSignup} fromURL={from} mode={mode}/>
          )}
          {currentScreen === "signup" && (
            <SignupScreen
              onNavigateToLogin={handleNavigateToLogin}
              onNavigateToOTP={handleNavigateToOTP}
              onSuccess={redirectAfterAuth}
            />
          )}
          {currentScreen === "otp" && (
            <OTPScreen phoneNumber={phoneNumber} onVerify={handleVerify} />
          )}
        </div>
      </div>
    </div>
  );
}
